import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CSketchComponent } from './c-sketch.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CElementsMarqueursModule } from '../../c-autres/c-elements-marqueurs/c-elements-marqueurs.module';
import { CSketchLegendeModule } from '../../c-autres/c-sketch-legende/c-sketch-legende.module';
import { CFormsDynamiquesModule } from '../c-forms-dynamiques/c-forms-dynamiques.module';

import { AsPipesModule } from '../../../pipes/as-pipes/as-pipes.module';

@NgModule({
  declarations: [CSketchComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    FontAwesomeModule,
    CElementsMarqueursModule,
    CSketchLegendeModule,
    CFormsDynamiquesModule,
    AsPipesModule,
  ],
  exports: [CSketchComponent]
})
export class CSketchModule { }
